import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { usePathFactory } from './Path/PathFactoryHook';
export function useNavigator() {
  const history = useHistory();
  const pathFactory = usePathFactory();
  const navigate = useMemo(() => route => history.push(pathFactory.create(route)), [history, pathFactory]);
  return navigate;
}